import { useStateMachine } from "little-state-machine";
import { updateEditDisposalSiteRequest } from "actions/updateEditDisposalSiteRequest";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import IUpdateDisposalSiteRequestModel from "interfaces/Request/IUpdateDisposalSiteRequestModel";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { getRegionIds } from "../DataMappers/ManageDisposalSiteMapper";

const EditTemplate = (props: any): any => {
  const navigate = useNavigate();
  const { actions } = useStateMachine({ updateEditDisposalSiteRequest });
  const {
    id,
    name,
    latitude,
    longitude,
    active,
    regions,
    nonWorkingPeriodIds
  } = props;

  const onEditClickHandler = () => {
    const updateDisposalSiteRequest: IUpdateDisposalSiteRequestModel = {
      id,
      name,
      latitude,
      longitude,
      active,
      regionIds: getRegionIds(regions),
      nonWorkingPeriodIds
    };

    actions.updateEditDisposalSiteRequest(updateDisposalSiteRequest);

    navigate(RoutePathsEnum.SettingsDisposalSitesUpdate);
  };

  return (
    <div className="d-flex justify-content-center">
      <Button
        variant="primary"
        data-testid="edit-disposalsite"
        aria-label={`Edit ${name} disposal site`}
        onClick={onEditClickHandler}
      >
        Edit
      </Button>
    </div>
  );
};
export default EditTemplate;
